/* Vaelor Shop by Make: puts each make's logo beside its name on the make tiles.
   Logos come from the 'Vehicle make' metaobject (Content > Metaobjects > Vehicle make),
   matched on match_key. Makes without a logo get a two-letter monogram tile so the grid lines up. */
(function () {
  function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function decorate(root, logos) {
    root.querySelectorAll('a.sbm-tile:not([data-sbm-logo])').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('make=') < 0 || href.indexOf('model=') > -1) return; // make tiles only
      var nameEl = a.querySelector('.sbm-tile__name');
      if (!nameEl) return;
      a.setAttribute('data-sbm-logo', '1');
      var name = nameEl.textContent.trim();
      var url = logos[norm(name)];
      var wrap = document.createElement('span');
      wrap.className = 'sbm-tile__logo';
      wrap.setAttribute('aria-hidden', 'true');
      if (url) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        wrap.appendChild(img);
      } else {
        wrap.className += ' sbm-tile__logo--mono';
        wrap.textContent = name.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();
      }
      a.insertBefore(wrap, a.firstChild);
      a.classList.add('sbm-tile--logo');
    });
  }

  function start() {
    document.querySelectorAll('[data-sbm]').forEach(function (root) {
      if (root.dataset.sbmLogosInit) return;
      root.dataset.sbmLogosInit = '1';
      var logos = {};
      try { logos = JSON.parse(root.getAttribute('data-logos') || '{}'); } catch (e) {}
      var body = root.querySelector('[data-sbm-body]');
      if (!body) return;
      decorate(root, logos);
      new MutationObserver(function () { decorate(root, logos); }).observe(body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
